import { useState } from 'react';

import { HKD, USDC } from '@constants/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import pubsub from '@lib/scripts/pubsub';

import { useMarketSymbols } from './useMarketSymbols';

type IParams = {
  coinCode: string;
}

export const useUsdRate = ({ coinCode }: IParams) => {
  const [marketSymbols, setMarketSymbols] = useState([]);
  const [usdRate, setUsdRate] = useState<number>();
  const storeMarketSymbols = useMarketSymbols();
  useIsomorphicLayoutEffect(() => {
    if (!marketSymbols?.length) {
      setMarketSymbols(storeMarketSymbols);
    }
    pubsub.subscribe('MARKET_SYMBOLS_CHANGE', setMarketSymbols)
    return () => {
      pubsub.unSubscribe('MARKET_SYMBOLS_CHANGE', setMarketSymbols)
    }
  }, [storeMarketSymbols])

  useIsomorphicLayoutEffect(() => {
    if (coinCode === USDC || !coinCode) return;
    if (coinCode !== HKD) {
      const coinSymbol = marketSymbols.find(item => item.coinCode === `${coinCode || 'USDT'}_USDC`);
      setUsdRate(Number(coinSymbol?.priceLast));
      return
    }
    const usdtUsd = marketSymbols.find(item => item.coinCode === 'USDT_USDC');
    const usdtHkd = marketSymbols.find(item => item.coinCode === 'USDT_HKD');
    const newUsdRate = Number(usdtUsd?.priceLast) / Number(usdtHkd?.priceLast);
    setUsdRate(newUsdRate)
  }, [marketSymbols, coinCode])
  return { usdRate }
}
